{
  "agreements": {
    "column": {
      "claim-option": "Claim option",
      "currency": "Currency",
      "description": "Description",
      "more": "more",
      "number": "No.",
      "type": "Type",
      "valid-from": "Valid from",
      "valid-to": "Valid to"
    },
    "header": {
      "intro": "View your current agreements. Click on the ‘submit claim’ button to initiate a claim.",
      "title": "Agreements overview"
    },
    "product": {
      "billback-rate": "Billback rate / kg.",
      "code": "LW Code",
      "name": "Products"
    },
    "table": {
      "detail": {
        "contact": "Contact:",
        "lwm-contact": "LW contact:",
        "download-pdf": "Download agreement PDF"
      },
      "empty": "No agreements available",
      "submit-claim": "Submit claim"
    },
    "type": {
      "billback": "Billback Agreement QTE"
    }
  },
  "amplify": {
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": "The password must contain the following requirements: Minimum password length of 6 characters; English uppercase alphabet characters (A-Z); English lowercase alphabet characters (a-z); Base 10 digits (0-9)",
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$; Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6": "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$; Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6",
    "Account recovery requires verified contact information": "Account recovery requires verified contact information",
    "An account with the given email already exists.": "An account with the given email already exists.",
    "Apply code from MFA app": "Enter the code from your multi-factor authentication service",
    "Apply code from SMS": "Enter the code sent to your mobile device.",
    "Back to Sign In": "Back to Sign In",
    "Cancel": "Cancel",
    "Change Password": "Change Password",
    "Code": "Code",
    "Confirm": "Confirm",
    "Confirm password": "Confirm password",
    "Confirm Sign In": "Confirm Sign In",
    "Confirm Sign Up": "We have sent you a confirmation code to your mail.",
    "Confirm a Code": "Confirm a Code",
    "Confirmation Code": "Confirmation Code",
    "Create Account": "Create Account",
    "Create a new account": "Create a new account",
    "Create account": "Create account",
    "Custom auth lambda trigger is not configured for the user pool.": "Password cannot be empty",
    "Email": "Email",
    "Email address": "Email address",
    "Enter your Email address": "Enter your Email address",
    "Enter your password": "Enter your password",
    "Enter your username": "Enter your username",
    "Forgot Password": "Forgot Password",
    "Forgot your password? ": "Forgot your password?",
    "Have an account? ": "Have an account?",
    "Incorrect username or password": "Incorrect username or password",
    "Invalid code received for user": "Invalid code received for user",
    "Invalid password format": "Invalid password format",
    "Invalid phone number format": "Invalid phone number format",
    "Loading": "Loading",
    "Lost your code? ": "Lost your code?",
    "New Password": "New Password",
    "No account? ": "No account?",
    "Password": "Password",
    "Password attempts exceeded": "Password attempts exceeded",
    "Phone Number": "Phone Number",
    "Please confirm your password": "Please confirm your password",
    "Remember this device": "Remember this device",
    "Resend Code": "Resend Code",
    "Reset password": "Reset password",
    "Reset your password": "Reset your password",
    "Send Code": "Send Code",
    "Set MFA": "Set MFA",
    "Sign In": "Sign In",
    "Sign Out": "Sign Out",
    "Sign Up": "Sign Up",
    "Sign in": "Sign in",
    "Sign in to your account": "Sign in to your account",
    "Skip": "Skip",
    "Submit": "Submit",
    "User already exists": "User already exists",
    "User does not exist": "User does not exist",
    "User does not exist.": "User does not exist.",
    "Username": "Username",
    "Username cannot be empty": "Username cannot be empty",
    "Username/client id combination not found.": "Username/client id combination not found.",
    "Verification Code": "Verification code",
    "Verify": "Verify",
    "Verify Contact": "Verify Contact",
    "Verify Token": "Verify Token"
  },
  "authentication": {
    "link-corporate": "Go to",
    "verification_message": "We have sent a confirmation code to your email address.",
    "warning": {
      "requires-mfa": "This is only available to users that have multi factor authentication enabled. You can setup your multi factor authentication in "
    }
  },
  "brand": {
    "name": "Lamb Weston"
  },
  "claims": {
    "column": {
      "amount": "Billback amount",
      "contract-no": "Contract no.",
      "description": "Description",
      "info": "Info",
      "posting-date": "Date",
      "status": "Status",
      "type": "Type"
    },
    "empty": "No claims available",
    "header": {
      "intro": "View your current claims.",
      "title": "Submitted claims overview"
    },
    "kg": "KG",
    "new": {
      "confirm-dialog": {
        "button": "Close message",
        "message": "Dear Customer, thank you for your input. Your claim will be reviewed and settled within 3 to 4 weeks. In case of questions please reach out to your LW/M commercial contact person.",
        "title": "Your claim has been submitted"
      },
      "footer": {
        "back": "Go back",
        "next": "Next",
        "submit": "Submit claim",
        "total-billback-amount": "Total billback amount",
        "total-claim-amount": "Total claim amount: ",
        "total-volume": "Total volume: "
      },
      "items": {
        "bags": "Bags",
        "billback-amount": "Billback amount",
        "billback-rate": "Billback rate",
        "boxes": "Boxes",
        "volume": "Volume"
      },
      "new-claim-button": "Submit new claim",
      "repeat-button": {
        "large1": "Want to start a different claim?",
        "large2": "Go back to claims overview",
        "small": "Claims overview"
      },
      "steps": {
        "claim-details": "Fill in claim details",
        "claim-summary": "Claim summary",
        "details": {
          "agreement-details": "Agreement details",
          "applicant": "Applicant",
          "currency": "Currency:",
          "header": "Claim details",
          "valid-range": "Valid from-to: {from} to {to}",
          "wholesale-party": "Wholesale party"
        },
        "details-form": {
          "credit-reference": {
            "label": "Credit reference",
            "placeholder": "Please fill in your credit reference"
          },
          "header": "Fill in claim details",
          "intro": "Please select the products for your rebate claim. We would kindly request you too also provide us with the wholesaler where you ordered your products.",
          "period": {
            "clear": "Clear",
            "label": "Claim period from - to",
            "placeholder": "Please select your claim period"
          },
          "wholesale-party": {
            "label": "Wholesale party",
            "placeholder": "Please fill in your wholesale party"
          }
        },
        "proof": {
          "attachment": {
            "label": "Please provide proof of purchase for all of the added items above",
            "placeholder": "Drag & drop files here or click to upload.  (max 25MB) {'|'} PDF, JPG, PNG, XLSX, DOCX, MSG supported"
          },
          "header": "Provide proof"
        },
        "summary": {
          "header": "Summary of your claim ",
          "your-billback-claim": "Your billback claim"
        }
      }
    },
    "overview": {
      "details": {
        "footer-message": "In case of questions please reach out to your LW EMEA Commercial contact person.",
        "title": "Claim overview"
      }
    },
    "search-bar": {
      "placeholder": {
        "search": "Search…"
      },
      "total": "Total"
    },
    "status": {
      "failed": "Failed",
      "submitted": "Submitted"
    }
  },
  "container-calculation": {
    "button": {
      "back": "Go back",
      "calculate": "Calculate",
      "download": "Download",
      "next": "Next"
    },
    "download": {
      "download": "Download your order calculation ",
      "file-type": "CSV file",
      "intro": {
        "done": "Your container order calculation is done!",
        "download": "You can download a CSV file with your container calculation "
      },
      "title": "Order calculation CSV download"
    },
    "header": {
      "intro": {
        "step-1": "Please indicate whether you would like us to use a slip sheet or pallets for your container order.",
        "step-2": "Add the desired products.",
        "step-3": "The system will calculate whether more articles are needed to maximize the container fill rate."
      },
      "title": "Select products for container"
    },
    "load-base": {
      "pallet": "Pallets",
      "sheet": "Sheets"
    },
    "result": {
      "filled": {
        "description": "please click  Next to continue.",
        "message": "Your current product selection fits into a container, "
      },
      "initial": {
        "description": "",
        "message": "We will assist you in filling the container as much as possible. Please enter pallet quantity and click Calculate. If applicable, the calculator will give feedback on optimizing container space."
      },
      "overfilled": {
        "description": "We have made a suggestion for you based on your most-ordered item. To accept, please click the orange button. You are free to make alternative adjustments by changing the quantity of any item in the list. Click Next once all container space has been filled.",
        "message": "To fill the container to its maximum capacity, pallets have to be removed."
      },
      "overfilled-no-product": {
        "description": "Your current product selection does not fit into the available container space. Please reduce your product selection by {count} pallets.",
        "message": "You have added too many pallets."
      },
      "totals": {
        "boxes": "Cartons:",
        "kg": "kg",
        "pallets": "Pallets:",
        "title": "Total",
        "weight": "Estimated gross weight:"
      },
      "underfilled": {
        "description": "We have made a suggestion for you based on your most-ordered item.  You can accept this configuration by clicking the orange button. You are free to make alternative adjustments by changing the  quantity of any item in the list. Click Next once all container space has been filled.",
        "message": "To fill the container to its maximum capacity, pallets have to be added."
      }
    },
    "steps": {
      "select-products": "Select products for container",
      "summary": "Order calculation CSV download"
    },
    "suggestion": {
      "add": "Add {amount}",
      "reduce": "Reduce {amount}"
    }
  },
  "contracts": {
    "contract": {
      "general": {
        "contract-no": "Contract No:",
        "to": "to",
        "total-volume": "Total contract volume:",
        "valid-from-to": "Valid from/to"
      }
    },
    "disclaimer": {
      "block-1": {
        "content": "Due to market changes, the information in your volume contracts may change. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit. Fusce facilisis sed augue sed maximus. Quisque non leo tempor, elementum tellus accumsan, hendrerit risus. Nam nec efficitur lorem. Quisque vitae eros diam.",
        "title": "Market changes"
      },
      "block-2": {
        "content": "Etiam vestibulum, sapien eu congue venenatis, orci sem euismod felis, at consectetur dui massa id felis. Nulla et odio felis. Ut congue in neque ut pretium. Etiam elementum, ligula eu consequat varius, nisi risus ultricies libero, sed tristique enim nibh at velit.",
        "title": "Product swapping in contracts\n"
      },
      "button": "Go to my volume contracts",
      "card": {
        "link": "disclaimer",
        "text": "Read our disclaimer for more information about possible variations in this overview"
      },
      "need-help": {
        "content": "If you have any follow up questions or need more detailed information about your volume contracts, please contact your {link}.",
        "link": "contact person or the customer experience team",
        "title": "Need help?"
      },
      "title": "Disclaimer"
    },
    "download": {
      "button": "Download",
      "label": "Select the contract info you want to download"
    },
    "header": {
      "intro": "Get insights into your contracts. If you have questions, please feel free to contact us.",
      "title": "My volume contracts"
    },
    "products": {
      "header": {
        "billed-qty": "Billed Qty KG",
        "code": "LW Code",
        "contract-qty": "Contr.Qty KG",
        "kg-left": "KG left",
        "material": "Material",
        "open-orders": "Open orders KG",
        "percent-left": "% Left",
        "product": "Product name"
      }
    }
  },
  "dashboard": {
    "invoices": {
      "go-to-my-invoices": "Go to my invoices",
      "my-invoices": "My invoices",
      "open-invoices": "Open invoices",
      "upcoming": "Upcoming",
      "your-open-invoices": "Your open invoices"
    },
    "orders": {
      "go-to-orders-overview": "Go to orders & deliveries overview",
      "last-order": "Last order",
      "my-orders-deliveries": "My Orders & Deliveries",
      "no-last-order": "No last order available",
      "order-date": "Order date",
      "order-status": "Order status",
      "your-orders-deliveries": "Your Orders & Deliveries"
    }
  },
  "e-learning": {
    "action": {
      "continue": "Continue",
      "enroll": "Enroll",
      "view": "View"
    },
    "course": {
      "finish": {
        "button": "I have finished this course",
        "description": "Please click on the button to confirm that you have finished this course",
        "title": "Have you finished this course?"
      },
      "header": {
        "back": "Back to overview",
        "status": "Status:"
      },
      "related": {
        "default-title": "Other courses"
      }
    },
    "minutes": "minutes",
    "overview": {
      "empty": "No courses found",
      "search-bar": {
        "category": {
          "all": "All",
          "placeholder": "Category: All"
        },
        "duration": {
          "all": "All",
          "more-than": "More than",
          "placeholder": "Duration: All"
        },
        "result-title": "({count}) Search results for: | ({count}) Search result for: | ({count}) Search results for: ",
        "search": {
          "placeholder": "Search..."
        },
        "status": {
          "all": "All",
          "placeholder": "Status: All"
        }
      },
      "title": "E-learning"
    },
    "status": {
      "completed": "Completed",
      "in-progress": "In progress",
      "not-started": "Not started"
    }
  },
  "eatThis": {
    "download": "download now",
    "open": "open now"
  },
  "error": {
    "error_404": {
      "title": "oops, page not found"
    },
    "error_500": {
      "title": "oops, error 500"
    },
    "general": {
      "subtitle": "it seems this page isn't working",
      "title": "oops, unknown error"
    }
  },
  "footer": {
    "copyright": "© {year} All rights reserved Lamb Weston",
    "navigation": {
      "privacy": "Privacy",
      "profile": "Profile",
      "terms-and-conditions": "Terms and conditions"
    }
  },
  "general": {
    "for": "for",
    "interface": {
      "back": "Back",
      "cancel": "Cancel",
      "close": "Close",
      "remove": "Remove",
      "save": "Save",
      "update": "Update",
      "none": "None",
      "noResultsFound": "No results found",
      "all": "All",
      "create": "Create",
      "next": "Next"
    },
    "locale": {
      "de": "German",
      "en-GB": "English",
      "es": "Spanish",
      "fr": "French",
      "it": "Italian",
      "nl": "Dutch"
    },
    "messages": {
      "error": "Something unexpected went wrong."
    },
    "table": {
      "not-available": "not available"
    },
    "dialog": {
      "confirm_delete_message": "Are you sure you want to delete this item?"
    }
  },
  "home": {
    "intro": "At Lamb Weston Customer Portal.",
    "title": "Welcome{fullname},",
    "subtitle": "Proudly serving {customerName}"
  },
  "invoices": {
    "column": {
      "amount": "Amount",
      "details": "Info",
      "expire-date": "Expiry date",
      "invoice-nr": "Invoice nr.",
      "posting-date": "Post date",
      "sales-order": "Sales order",
      "sales-order-show": "show",
      "status": "Status"
    },
    "detail": {
      "label": {
        "amount": "Amount",
        "currency": "Currency",
        "expire-date": "Expiry date",
        "invoice-number": "Invoice no.",
        "order-reference": "Order reference",
        "payment-terms-code": "Payment terms code",
        "payment-terms-description": "Payment terms description",
        "posting-date": "Post date",
        "relevant-bill-to": "Relevant Bill-to",
        "relevant-payer": "Relevant payer",
        "sales-order-ship-to": "Sales order Ship-to",
        "type-commercial": "Type commercial"
      },
      "pdf-download": "PDF download Invoice",
      "sales-order": {
        "close": "Close message",
        "order-overview": "Go to My Orders",
        "title": "Invoice {invoice} - Sales order"
      },
      "show-sales-order": "show sales order"
    },
    "empty": "No invoices available",
    "header": {
      "intro": "On this page you can find and download your invoices. Click on a row for more information.",
      "title": "My invoices"
    },
    "search-bar": {
      "placeholder": {
        "all-invoices": "All invoices",
        "filter": "Filter invoices",
        "search": "Search…"
      },
      "total": "Total",
      "total-filtered": "Total filtered"
    },
    "status": {
      "before due": "due payment",
      "cleared": "paid",
      "days-till-due-date": "{count} days|{count} day|{count} days",
      "due date": "due date",
      "overdue": "overdue",
      "reversed": "reversed"
    }
  },
  "menuEngineering": {
    "categories": {
      "laggard": "laggard",
      "runner": "runner",
      "sleeper": "sleeper",
      "winner": "winner"
    },
    "imageAlt": {
      "icon": "Category chef icon",
      "laggard": "Chef laggard category",
      "runner": "Chef runner category",
      "sleeper": "Chef sleeper category",
      "winner": "Chef winner category"
    },
    "label": {
      "addDishEquation": "Your dish has been added to the equation",
      "categoryResult": {
        "intro": "Below you find the results of your dishes in the four categories of",
        "link": "menu-engineering",
        "outro": "Click on the category to see which of your dishes fall into that category and get advice on optimizing your dishes."
      },
      "companySeatCount": "How many seats do you have",
      "companyStaffSize": "How big is your staff",
      "cost": "Food cost (€)",
      "course": {
        "breakfast": "Breakfast",
        "dinner": "Dinner",
        "inbetween": "In between",
        "lunch": "Lunch",
        "snack_time": "Snack time"
      },
      "courseDish": "Course",
      "dishNotDeleted": "Dish could not be deleted",
      "editDish": "Your dish has been edited",
      "goodCalculation": "We need at least 5 dishes for a proper calculation.",
      "helpTime": "Kitchen help time (min)",
      "info": {
        "cost": "The total cost price of all ingredients in the dish.",
        "helpTime": "Time spent by kitchen staff preparing this dish.",
        "popularity": "How many items of this dish are being sold per week.",
        "price": "The selling price of the dish on the menu before taxes.",
        "time": "Time spent by the chef preparing this dish."
      },
      "insufficientDishes": "We need at least {count} more dishes to make a proper calculation.",
      "laggard": {
        "demand": "Low demand",
        "profit": "Low profit"
      },
      "laggards": "Laggards",
      "nameOfDish": "Name of the dish",
      "optionRestaurant": "Restaurant",
      "popularity": "Popularity (times a week)",
      "price": "Selling price excl. VAT (€)",
      "runner": {
        "demand": "High demand",
        "profit": "Low profit"
      },
      "runners": "Runners",
      "selectCourse": "Course",
      "selectCourseLabel": "Choose a course",
      "sleeper": {
        "demand": "Low demand",
        "profit": "High profit"
      },
      "sleepers": "Sleepers",
      "thinkOfYourDish": "Think of one of your dishes. And fill in the form.",
      "time": "Chef time (min)",
      "typeOfRestaurant": "What type of restaurant do you have?",
      "winner": {
        "demand": "High demand",
        "profit": "High profit"
      },
      "winners": "Winners"
    },
    "overview": {
      "addAnotherDish": "Save & add another one",
      "addDish": "Add a dish",
      "addDishEquation": "Add a dish to the equation",
      "calculateNow": "Calculate now",
      "cancel": "Cancel",
      "categoryCompare": "Compared to other dishes in your market, your dish appears to be a",
      "categoryResult": {
        "intro": "These are the",
        "outro": "courses of your menu"
      },
      "deleteProfile": "You are about to delete your profile",
      "dishes": "Dishes",
      "menuEngineering": "Menu Engineering",
      "results": "Results",
      "save": "Save",
      "showResults": "Show the results",
      "startMenuEngineering": "Start engineering your menu",
      "testValueDishes": "Test the value of your dishes",
      "typeOfRestaurant": "Type of restaurant",
      "yourDish": "Your dish"
    },
    "placeholder": {
      "typeOfRestaurant": "i.e. steakhouse, pizzeria, etc"
    },
    "results": {
      "back-to-results": "Back to my results",
      "title": "My menu engineering results"
    },
    "try-out": {
      "dish-form": {
        "subtitle": "Think of one of your dishes. And fill in the form.",
        "title": "2. Your dish"
      },
      "hero": {
        "subtitle": "Menu engineering helps evaluate your dishes on the menu and get an overview of your best and worst performers.",
        "title": "Test the real value of your dishes"
      },
      "intro": {
        "text": "Menu engineering compares the dishes relative to each other, you will therefore always have winners, sleepers, runners and laggards. In order to get a good result only compare similar dishes of the menu such as the segment “main courses”.",
        "title": "Menu engineering",
        "try": "Try it for one dish below!"
      },
      "restaurant-type": {
        "label": "Can you tell us what restaurant?",
        "subtitle": "What type of restaurant do you have?",
        "title": "1. Type of restaurant"
      },
      "result": {
        "sign-up": "Join us to compare your dishes"
      }
    }
  },
  "navigation": {
    "approved-products": "{company} Portfolio",
    "back-to-overview": "Back to overview",
    "best-practices": "Best practices/Playbook",
    "container-calculation": "Container calculation",
    "dashboard": "Dashboard",
    "e-learning": "E-learning",
    "eat-this": "Eat This!",
    "lwm-company-information": "Lamb Weston Company",
    "lwm-contact": "Lamb Weston Contacts",
    "market-activations": "Market activations",
    "menu-engineering": {
      "add-dish": "Add dish",
      "main": "Menu Engineering",
      "my-results": "My results",
      "try-out": "Test the real value of your dishes"
    },
    "my-agreements": "My agreements",
    "my-claims": "My claims",
    "my-invoices": "My invoices",
    "my-orders": "My orders & deliveries",
    "my-volume-contracts": "My volume contracts",
    "new-products": "Innovations & Trends",
    "partnership": "{company} Partnership",
    "permission-mgt": "Permission management",
    "product-information": "Product information",
    "products-for": "{company} Portfolio",
    "settings": {
      "main": "Settings",
      "my-profile": "My profile"
    },
    "sign-out": "Sign out",
    "sustainability": "Sustainability Agenda",
    "training": "Operations & Training",
    "trend-information": "Trend information",
    "user-management": "User management",
    "dock-scheduler": "Dock scheduler",
    "dock-scheduler-booking": "Booking overview",
    "dock-scheduling-rules": "Dock scheduling rules"
  },
  "onboarding": {
    "authenticator": {
      "error": {
        "InvalidParameterException": "The validation code should be 6 characters long.",
        "unknown": "Something went wrong, please try again."
      },
      "finish": "Finish",
      "qr-description": "Scan the QR Code with your authentication app to get the MFA code.",
      "qr-title": "MFA Code",
      "step-title": "Set the authentication token",
      "steps": "Download the Google authenticator app in the Apple or Android store|Press the “+” icon|Select “Scan QR-code”|Enter the code from the app in the “Verification code” field",
      "title": "Authenticator App"
    },
    "change-mfa": "Change",
    "finished": {
      "features-enabled": "All portal features are now available.",
      "finish": "Go to dashboard",
      "intro": {
        "authenticator": "Thank you for setting up Multi-Factor Authentication.\nFrom now on you can sign in using Multi-factor authentication with your authenticator app.",
        "sms": "Thank you for setting up Multi-Factor Authentication.\nFrom now on you can sign in using Multi-factor authentication with a text message on your phone."
      },
      "title": "Authentication verified!"
    },
    "mfa-preference": "Multi-Factor Authentication Preference",
    "none": {
      "description": "If you have not set up Multi-Factor Authentication, you can only use the Portal features that do not require MFA. If you proceed without setting up MFA, you will be shown this popup again on your next visit.",
      "finish": "Use without MFA",
      "title": "Do not enable MFA"
    },
    "sms": {
      "change-phone": "Change phonenumber",
      "code-sent": "We have sent a code to your phone.",
      "finish": "Finish",
      "request-code": "Request code",
      "steps": "Enter your phone number and press Request code|Within a few seconds you should receive a text message with a verification Code|Enter the verification code and press Finish to activate.",
      "title": "SMS text messaging"
    },
    "welcome": {
      "buttons": {
        "authenticator": {
          "label": "(use a QR code and MFA app to save a token on your mobile device)",
          "type": "Authenticator App"
        },
        "none": {
          "label": "",
          "type": "Do not enable MFA"
        },
        "sms": {
          "label": "(receive a code on your mobile device).",
          "type": "SMS text messaging"
        }
      },
      "explanation-description": "Multi-Factor Authentication (MFA) adds an extra layer of protection on top of your username and password. To enable SMS authentication, please provide a valid mobile number above.",
      "explanation-title": "Multi-Factor Authentication Preference",
      "recommend-description": "For safety purposes we also recommend using Multi-Factor Authentication.",
      "required-description": "Welcome to your Customer Portal! In order to  access to all customer portal features, you need Multi-Factor Authentication. ",
      "title": "Welcome!"
    }
  },
  "orders": {
    "card": {
      "footer": {
        "order-again": "Order these products again",
        "reorder": "Want to reorder this order? Click on the order these products again button.",
        "summary-info": "* The composition of the order may vary according to stock availability; confirmation of items and quantities will follow. Lamb Weston,  in cooperation with its logistic partners, will do its utmost best to satisfy your preferred delivery date, but the actual delivery date will be communicated to you at a later stage."
      },
      "header": {
        "bill-of-lading": "BOL:",
        "close": "close",
        "container-numbers-long": "Container Numbers ({count})",
        "container-numbers-short": "No.",
        "more": "more",
        "order-city": "Destination: ",
        "order-date": "Order date: ",
        "order-no": "LW #: ",
        "order-ref": "Order ref: ",
        "order-reference": "Order reference:",
        "products-to-order": "Products to order"
      },
      "status": {
        "delivery-date": "Delivery:",
        "label": "Status:",
        "more-info": "more info about order status"
      }
    },
    "group": {
      "last-order": "Your last order",
      "see-products": "click to see products"
    },
    "header": {
      "intro": "You can enter new orders, view your order history or quickly re-order a previous order below. ",
      "new-order-button": "Place new order",
      "title": "My Orders"
    },
    "new": {
      "confirm-dialog": {
        "button": "Close message",
        "message": "Thank you for ordering at Lamb Weston. We've successfully received your preferred order. The details and payment of your order will be sent to your email address.",
        "title": "Your order has been sent"
      },
      "footer": {
        "back": "Go back",
        "cancel": "Cancel",
        "confirm": "Confirm order",
        "next": "Next",
        "recalculate": "Recalculate"
      },
      "preferred-warehouse": "**You've selected the warehouse: {code},** because of this selection for this order you can **only order products from this warehouse.** If you wish to order products from **another warehouse**, please **create a separate order.**\"",
      "help-text": "Product naming consists of cut sizes and the weight of the cases.",
      "intro": "You can place your orders quickly and easily. Once the order has been entered into the system and been processed you will be contacted by our Customer Experience department for payment and delivery details.",
      "products-title": "Lamb Weston Product Range",
      "products-unavailable": {
        "button": "Go to product selection",
        "item-label": "Not available",
        "message": "Your current re-order contains a product that is no longer available. Please select an alternative product on the product selection screen. We have added the other products from the previous order to your order list.",
        "title": "Order these products again - {count} product(s) not available"
      },
      "repeat-button": {
        "large1": "Want to repeat a previous order?",
        "large2": "Go back to order overview",
        "small": "repeat order?"
      },
      "steps": {
        "order-reference-and-shipping": "Order Reference & Shipping",
        "order-summary-and-confirmation": "Order Summary & Confirmation",
        "select-products": "Select products"
      },
      "suggest-fill-scale": {
        "footer": {
          "message": "To accept, please click the orange button. You are free to make alternative adjustments by changing the quantity of any item in the list or you can ignore our suggestion and proceed to the next step of the ordering process.",
          "title": "Allow us to optimise your order! We have made a suggestion for you so your order fits in the next order volume scale."
        },
        "tooltip": {
          "message": "Add **+{quantity}** pallet(s) to benefit from lower freight rates.",
          "title": "Allow us to optimise your order!"
        }
      },
      "suggest-fill-truck": {
        "footer": {
          "message": "To accept, please click the orange button. You are free to make alternative adjustments by changing the quantity of any item in the list or you can ignore our suggestion and proceed to the next step of the ordering process.",
          "title": "Allow us to optimise your order! We have made a suggestion for you so your order fills up the truck."
        },
        "tooltip": {
          "message": "Add **+{quantity}** pallet(s) to fill up the truck.",
          "title": "Allow us to optimise your order!"
        }
      },
      "suggest-remove": {
        "footer": {
          "message": "We have made a suggestion for you based on your highest quantity order line. To accept, please click the orange button. You are free to make alternative adjustments by changing the quantity of any item in the list. Click recalculate after you have adjusted your order to continue.",
          "title": "You have exceeded the max. truck load by {quantity} pallet(s) ({exceededWeight} kg, including pallets)."
        },
        "tooltip": {
          "message": "Reduce quantity for this item by **-{quantity}**. Cancel to reduce quantity for other items.",
          "title": "You have exceeded the max. truck load."
        }
      },
      "suggestion": {
        "accept": "Accept",
        "cancel": "Cancel"
      },
      "title": "New order"
    },
    "custom-label-switch": {
      "title": "Show original labels",
      "description": "This will show the original product information provided by LambWeston when switched on.",
      "checkbox": "Show original product name and no."
    },
    "order-item-list": {
      "header": {
        "art": "Material",
        "boxes": "Cartons",
        "code": "LW code",
        "warehouse": "Warehouse",
        "layers": "Layers",
        "pallets": "Pallets",
        "product": "Product",
        "products": "Products",
        "quantity": "Quantity",
        "unit-type": "Unit type"
      },
      "totals": {
        "grand-total": "Grand total",
        "kg": "kg",
        "total-cartons": "Cartons | Carton | Cartons",
        "total-gross-weight": "Gross Weight",
        "total-layers": "Layers | Layer | Layers",
        "total-net-weight": "Net Weight",
        "total-pallets": "Pallets | Pallet | Pallets"
      },
      "unit": {
        "bag": "Bag",
        "car": "Cartons",
        "kg": "kg",
        "lay": "Layers",
        "pal": "Pallets"
      }
    },
    "overview": {
      "closed-orders-title": "Closed orders",
      "empty": "No orders available",
      "header": {
        "eta-actual": "ETA actual",
        "eta-booked": "ETA booked",
        "eta-requested": "Req. ETA",
        "more": "more",
        "order-city": "Destination",
        "order-date": "Order date",
        "order-no": "LW #",
        "order-ref": "Order ref",
        "order-reference": "Order reference",
        "order-status": "Order status"
      },
      "open-orders-title": "Open orders",
      "search-bar": {
        "query": {
          "placeholder": "Search for a specific order…"
        },
        "status": {
          "all": "All orders",
          "placeholder": "Order Status"
        }
      }
    },
    "reference": {
      "intro": "If you want to add an order reference/purchase order number for your order please fill out the order reference field.",
      "number": {
        "max-characters": "(max 20 characters)",
        "placeholder": "Add your order reference number",
        "title": "Order reference"
      },
      "title": "Your order reference"
    },
    "search-bar": {
      "placeholder": {
        "set-preferred-warehouse": "Set preferred warehouse",
        "filter-products": "Filter products",
        "search": "Search for a specific product ...",
        "search-alt": "search"
      }
    },
    "shipping": {
      "delivery-date": {
        "label": "this date is an estimation",
        "title": "Preferred delivery date"
      },
      "eta": {
        "delayed": "delayed",
        "early": "early",
        "eta": "ETA:"
      },
      "ship-to": {
        "title": "Ship to"
      },
      "title": "Shipping"
    },
    "status": {
      "AWS_CREATED": "Received by Lamb Weston",
      "DELIVERED": "Delivered",
      "SAP_CANCELLED": "Cancelled",
      "SAP_CREATED": "Accepted",
      "SAP_PROCESSING": "Processing",
      "SAP_PROCESSING_PART": "Processing",
      "SAP_SHIPPED": "Shipped",
      "SAP_SHIPPED_PART": "Shipped",
      "SAP_UNKNOWN": "Unknown",
      "more-info": {
        "AWS_CREATED": "Order has been completed and confirmed through Customer Portal. Confirmation mail sent.",
        "DELIVERED": "Confirmation goods have been delivered to the ship to location.",
        "SAP_CANCELLED": "Order has been cancelled.",
        "SAP_CREATED": "Order has been completed, outbound created, no blocks, no rejections.",
        "SAP_PROCESSING": "Order is being processed and checked by LW Customer Experience.",
        "SAP_PROCESSING_PART": "Processing in SAP, partly accepted order.",
        "SAP_SHIPPED": "Order has been shipped,  PGI received.",
        "SAP_SHIPPED_PART": "SAP delivery created, partly accepted order.",
        "SAP_UNKNOWN": "Please contact your Customer Experience representative for more information."
      },
      "part": "partly",
      "partly": "not in full"
    },
    "summary": {
      "delivery-date": "Ship to and preferred delivery date",
      "title": "Summary of your order"
    },
    "warning": {
      "requires-mfa": "Order management is only available to users who have multi-factor authentication enabled. You can set up your multi factor authentication in:"
    }
  },
  "permission-mgt": {
    "column": {
      "actions": {
        "delete": "Delete",
        "get": "Read",
        "label": "Actions",
        "post": "Create",
        "put": "Update",
        "tooltip": "More information about actions"
      },
      "configure": {
        "label": "Configure",
        "tooltip": "More information about configure"
      },
      "delete": {
        "label": "Delete",
        "tooltip": "More information about delete"
      },
      "effect": {
        "label": "Effect",
        "tooltip": "More information about effect"
      },
      "endpoint": {
        "label": "Endpoint",
        "tooltip": "More information about endpoint"
      },
      "field": {
        "label": "Field"
      },
      "model": {
        "label": "Model"
      },
      "operator": {
        "label": "Operator"
      },
      "value": {
        "label": "Value"
      },
      "wildcard": {
        "label": "For wildcard endpoint",
        "tooltip": "More information about wildcard"
      }
    },
    "effect": {
      "allow": "Allow",
      "deny": "Deny"
    },
    "intro": "Manage user roles and their permissions. Please select a role first or add a new role.",
    "policies": {
      "add": "Add new policy",
      "configure": {
        "actions": "Actions",
        "effect": "Effect",
        "endpoint": "Endpoint",
        "for-wildcard-endpoint": "For wildcard endpoint",
        "id": "ID",
        "locale": "Locale",
        "title": "Configure Policy",
        "wildcard": "Wildcard"
      },
      "delete": {
        "cancel": "Cancel",
        "confirm": "Delete policy",
        "message": "Are you sure you want to delete this policy? This action cannot be undone.",
        "success": "Policy deleted successfully",
        "title": "Deleting policy"
      },
      "intro": "Policies for this role. You can configure policies for this role by clicking the configure button and "
    },
    "policy-form": {
      "cancel": "Cancel",
      "endpoint": {
        "label": "Endpoint",
        "placeholder": "Select an endpoint"
      },
      "filters": {
        "add": "Add new filter",
        "title": "Policy filters"
      },
      "placeholder": {
        "select": {
          "field": "Select a field",
          "model": "Select a model",
          "operator": "Select a operator"
        }
      },
      "submit": "Save & exit",
      "title": "Configure Policy"
    },
    "role": {
      "add": "Add new role",
      "edit": "Edit role name",
      "form": {
        "cancel": "Cancel",
        "error": "An error occurred when saving the role",
        "name": {
          "label": "Name",
          "placeholder": "Enter the name of the role"
        },
        "submit": "Save",
        "success": "The role has been saved",
        "title": "Role"
      },
      "placeholder": "Select a role"
    },
    "select-role": "Please select a role first or click add new role.",
    "title": "Permission management"
  },
  "product-information": {
    "contact": {
      "description": "Want to enquire about a new product? Or request product information about a product that is not in your list?",
      "link": "Contact Customer Experience",
      "subject": "Customer Portal product information"
    },
    "detail": {
      "intro": "Here you can find all available product information for this product.",
      "packaging": {
        "cartons": "cartons",
        "cm": "cm",
        "commodity-code": "HS Customs Code",
        "dimensions": "Dimensions",
        "ean-upc": "EAN Number",
        "gross-weight": "Gross Weight",
        "height": "height",
        "kg": "kg",
        "layers": "layers",
        "length": "length",
        "material": "Material",
        "net-weight": "Net Weight",
        "pallet-type": "Pallet Type",
        "shelf-life-code": "Shelf life code",
        "title": "Packaging & Dimensions",
        "unit": {
          "bag": "Packaging/Bag",
          "car": "Carton",
          "lay": "Layer",
          "pal": "Pallet"
        },
        "width": "width"
      },
      "product-sheet": {
        "download-button": "Download product sheet pdf",
        "information-list": "Nutritional information|Allergen information|Cooking information|Example information",
        "intro": "On this commercial product specification sheet, you can find the following information.",
        "subtitle": "Commercial Product Specification Sheet PDF",
        "title": "Product sheet"
      }
    },
    "header": {
      "intro": "You can find all the available product information here. Click on more info for product details.",
      "title": "Product information"
    },
    "list": {
      "empty": "No products available",
      "header": {
        "details": "more info",
        "download": "download pdf"
      }
    }
  },
  "profile": {
    "account-settings": {
      "edit": "Edit account settings",
      "title": "Account settings"
    },
    "edit": "edit",
    "email": {
      "confirmation-code": "Enter your confirmation code"
    },
    "error": {
      "failed": "An error occurred while saving your profile",
      "success": "Your profile has been saved",
      "wrongPassword": "You entered an incorrect password"
    },
    "label": {
      "cancel": "Cancel",
      "change-password": "****************",
      "city": "City",
      "country": "Country",
      "edit": "Edit profile",
      "email": "Email address",
      "firstName": "First name",
      "functionTitle": "Job title",
      "lastName": "Last name",
      "locale": "Language",
      "newPassword": "New password",
      "newPasswordRepeat": "Re-enter password",
      "oldPassword": "Old password",
      "phone": "Telephone number",
      "restaurantCity": "City",
      "restaurantCountry": "Country",
      "restaurantName": "Restaurant name",
      "restaurantNumber": "Number",
      "restaurantPostalcode": "Postal code",
      "restaurantSeats": "Covers",
      "restaurantStreet": "Street",
      "restaurantTelephone": "Telephone",
      "restaurantType": "Restaurant type",
      "restaurantWebsite": "Website",
      "save": "Save"
    },
    "locale": {
      "change-success": "Your language has been successfully changed"
    },
    "mfa": {
      "current-mfa": "Installed: ",
      "method": {
        "NOMFA": "no multifactor authentication",
        "SMS": "SMS text messaging (receive a code on your mobile device)",
        "TOTP": "one-time password (with authenticator app)"
      },
      "mfa-description": "Multi-Factor Authentication (MFA) adds an extra layer of protection on top of your username and password. To enable SMS authentication, please provide a valid mobile number above",
      "no-mfa-description": "Do not enable MFA",
      "setup-mfa": "Multi-factor authentication preference",
      "sms-description": "SMS text messaging (receive a code on your mobile device). Please make sure your phone number is correct.",
      "token-instructions": "Scan the QR Code with your phone camera or authentication app to get the MFA code.",
      "totp-description": "One-time password (use a QR code and MFA app to save a token on your mobile device)",
      "totp-info": {
        "1-select-option": "Select “One-time password” and click on “Set MFA”",
        "2-get-app": "Get the {0} for your mobile device",
        "2-get-app-link": "Google authenticator app",
        "3-press-plus": "Press the “+” icon",
        "4-select-scan": "Select “Scan QR-code”",
        "5-enter-code": "Enter the code from the app in the “Verification code” field",
        "title": "How to set up one-time password authentication"
      }
    },
    "no-profile-placeholder": "Please complete your profile to enjoy an optimal customer portal experience. Click on the icon in the right corner to edit your profile.",
    "password": {
      "change-success": "Your password has been successfully changed",
      "do-not-match": "Passwords do not match",
      "invalid": "The password must contain the following requirements: Minimum password length of 6 characters; English uppercase alphabet characters (A-Z); English lowercase alphabet characters (a-z); Base 10 digits (0-9)."
    },
    "phone": {
      "invalid-phone-number": "You have not entered a valid phone number",
      "unknown-error": "Something went wrong,  your phone number could not be saved"
    },
    "placeholder": {
      "city": "IE London, Rome",
      "close": "Closing",
      "confirmation-code": "123456",
      "country": "Select your country",
      "email": "mail@chefs.network",
      "functionTitle": "IE Chef, Sous-chef etc.",
      "number": "IE 9, Appartment 12F etc",
      "open": "Opening",
      "password": "Password",
      "phone": "555-3891203812",
      "restaurant": {
        "seats": "i.e. 100",
        "type": "i.e. steakhouse, pizzeria etc."
      },
      "staff": "IE 2",
      "street": "IE Main street",
      "zip": "IE W1U 3BW, 00118 etc"
    },
    "restaurant": {
      "add": "Add another restaurant",
      "address": "Address",
      "basic": "Basic",
      "delete": {
        "confirm": "Delete restaurant",
        "message": "Are you sure you want to delete this restaurant?",
        "success": "Your restaurant has been deleted",
        "title": "You are about to delete a restaurant"
      },
      "delete-success": "Your restaurant has been deleted",
      "edit": "Edit restaurant information",
      "save-success": "Your restaurant has been saved",
      "seats": "Covers",
      "title": "Restaurant information",
      "type": {
        "(mountain) huts": "(Mountain) Huts",
        "american diner": "American diner",
        "american_diner": "American diner",
        "bar": "Bar",
        "beach resorts": "Beach resorts",
        "beach_resorts": "Beach resorts",
        "bistro": "Bistro",
        "camp sites": "Campsites",
        "camp_sites": "Campsites",
        "chicken restaurant": "Chicken restaurant",
        "chicken_restaurant": "Chicken restaurant",
        "fast food": "Fast food",
        "fast_food": "Fast food",
        "fish Burger": "Fish burger",
        "fish_burger": "Fish burger",
        "gourmet restaurant": "Gourmet restaurant",
        "gourmet_restaurant": "Gourmet restaurant",
        "grill restaurant": "Grill restaurant",
        "grill_restaurant": "Grill restaurant",
        "hamburger Restaurant": "Hamburger restaurant",
        "hamburger_restaurant": "Hamburger restaurant",
        "mountain_huts": "(Mountain) Huts",
        "other": "Other",
        "pizza restaurant": "Pizza restaurant",
        "pizza_restaurant": "Pizza restaurant",
        "pub": "Pub",
        "seafood restaurant": "Seafood restaurant",
        "seafood_restaurant": "Seafood restaurant",
        "snack bar": "Snack bar",
        "snack_bar": "Snack bar",
        "steakhouse": "Steakhouse"
      }
    },
    "title": "Profile"
  },
  "registration": {
    "label": {
      "password": "Password",
      "restaurantName": "Please give the name of the restaurant for which you want to do the Menu Engineering calculation."
    },
    "placeholder": {
      "restaurantName": "Restaurant name"
    }
  },
  "updates-modal": {
    "general": {
      "close": "Close"
    },
    "scopes": {
      "new-product-cold-store": {
        "button-text": "Update! New features.",
        "read-more": "Read more",
        "title": "Update! New features.",
        "content": [
          {
            "title": "Dear customer",
            "content": "Please be informed that we have made some changes in our Customer Portal. There is now the possibility to have your product description and your product number displayed in the customer portal. In case you are missing any of your products or descriptions do not hesitate to send this information to your contact within Lamb Weston",
            "image": "/img/updates/new-product-cold-store/en-GB/1.jpg"
          },
          {
            "content": "In case you only want to see Lamb Weston codes and descriptions you can check this box.",
            "image": "/img/updates/new-product-cold-store/en-GB/2.jpg"
          },
          {
            "content": "From now on, we will show the place where the delivering warehouse is located.",
            "image": "/img/updates/new-product-cold-store/en-GB/3.jpg"
          },
          {
            "content": "In case you have other questions considering these changes please reach out to your contact person at Lamb Weston."
          }
        ]
      }
    }
  },
  "user-management": {
    "add": {
      "email": {
        "label": "Email address",
        "placeholder": "The user's email address…."
      },
      "error-message": "An error occured while adding the user.",
      "intro": "Fill out the information below and click the add user button to add a new user.",
      "locale": {
        "label": "Language",
        "placeholder": "Select the preferred language"
      },
      "mfa": {
        "phone": "Telephone number",
        "title": "Multi-factor authentication preference",
        "use-sms-mfa": "SMS text messaging (receive a code on your mobile device)"
      },
      "sap-id": {
        "customer": "Customer:",
        "label": "SAP ID",
        "no-portal-access": "This customer does not have access to the Customer Portal.",
        "placeholder": "SAP ID consists of max. 12 characters…",
        "unknown-sap-id": "Unknown SAP ID"
      },
      "success-message": "The user was added successfully.",
      "user-group": {
        "label": "User group",
        "placeholder": "Select the user group"
      }
    },
    "add-new-user": "Add new user",
    "change-roles": {
      "form": {
        "cancel": "Cancel",
        "error": "The user roles could not be saved",
        "label": "Change Role(s)",
        "placeholder": "Add a role",
        "remove": "Remove this role",
        "submit": "Save",
        "success": "The user roles have been saved successfully"
      }
    },
    "change-user-group": {
      "form": {
        "cancel": "Cancel",
        "error": "The user group could not be changed",
        "group": {
          "administrators": "Administrator",
          "any": "Any",
          "direct-customers": "Direct customer",
          "end-users": "End users",
          "indirect-customers": "Indirect customer",
          "multinationals": "Multinational",
          "none": "None",
          "dock-scheduling-users": "Dock scheduling user",
          "dock-scheduling-employees": "Dock scheduling employee"
        },
        "label": "Change user group",
        "submit": "Save",
        "success": "The user group has been changed successfully"
      }
    },
    "column": {
      "customer": "Customer",
      "details": "Edit",
      "email": "Email",
      "first-name": "First name",
      "last-name": "Surname",
      "status": "Status",
      "user-group": "User group",
      "vendor": "Partner"
    },
    "details": {
      "change-roles": "Change roles",
      "change-user-group": "Change user group",
      "impersonate": "Impersonate this user",
      "language": "Language:",
      "manage-user-intro": "You can reset this user's password or two-factor authentication by clicking the buttons below.",
      "manage-user-title": "Manage this user",
      "reset-mfa": "Reset 2FA",
      "reset-password": "Reset password",
      "sap-id": "SAP ID:",
      "sap-id-error": "The SAP ID could not be changed",
      "sap-id-placeholder": "Add SAP ID",
      "sap-id-success": "The SAP ID has been changed",
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "toggle-active-intro": "By switching the toggle below you can activate or deactivate the user.",
      "toggle-active-title": "Activate & deactivating user"
    },
    "group": {
      "administrators": "Administrators",
      "direct-customers": "Direct customers",
      "end-users": "End users",
      "indirect-customers": "Indirect customers",
      "dock-scheduling-users": "Dock scheduling user",
      "dock-scheduling-employees": "Dock scheduling employee"
    },
    "group-short": {
      "administrators": "Admin",
      "any": "Any",
      "direct-customers": "Direct customer",
      "end-users": "End users",
      "indirect-customers": "Indirect cust.",
      "multinational": "Multinational",
      "none": "None",
      "dock-scheduling-users": "Dock scheduling user",
      "dock-scheduling-employees": "Dock scheduling employee"
    },
    "impersonate": {
      "bar": {
        "impersonating_as": "You are currently impersonating as",
        "stop": "stop impersonating"
      },
      "dialog": {
        "cancel": "Cancel",
        "confirm": "Impersonate",
        "message": "Are you sure you want to impersonate \"{email}\"?",
        "title": "Impersonate user"
      }
    },
    "intro": "Manage your users. Click on a user row for more info or possible user actions.",
    "reset-mfa": {
      "cancel": "Cancel",
      "confirm": "Confirm",
      "error": "An error occured while resetting two-factor authentication.",
      "message": "Are you sure you want to reset two-factor authentication for this user?",
      "success": "Two-factor authentication has been reset.",
      "title": "Reset two-factor authentication"
    },
    "reset-password": {
      "cancel": "Cancel",
      "confirm": "Confirm",
      "error": "An error occured while resetting the password.",
      "message": "Are you sure you want to reset the password for this user?",
      "success": "The password has been reset.",
      "title": "Reset password"
    },
    "search-bar": {
      "placeholder": {
        "all-user-groups": "All user groups",
        "search": "Search ...",
        "search-alt": "search",
        "users": "Users"
      }
    },
    "status": {
      "active": "active",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "inactive": "inactive",
      "message": "Are you sure you want to change the status of the user?",
      "title": "Activate & deactivating user"
    },
    "title": "User management",
    "update-vendor-button": "Update partner",
    "vendor-label": "Partner",
    "vendor-tooltip": "There is currently no direct integration with the vendor’s SAP system. Setting a value allows an administrator to create bookings for this partner based on this value.",
    "product-groups-label": "Product groups",
    "update-product-groups-button": "Update product groups"
  },
  "validation": {
    "ext": "Only files with the extension '{ext}' are accepted.",
    "required": "This field is required",
    "totalSize": "You can not upload more than {totalSize}Mb",
    "quarterly": "The selected months do not form a valid quarter",
    "no-special-characters": "The input cannot contain hashtags, quotes, asterisks, or commas.",
    "password": "The password needs a minimum of {length} characters",
    "password-repeat": "The passwords do not match",
    "email": "Please enter a valid email address",
    "max": "This field must be at most {max} characters long.",
    "afterTime": "End time must be later than start time",
    "min": "This field must be at least {min} characters long."
  },
  "dock-management": {
    "dock-scheduler-title": "Dock scheduler",
    "select-location": "Location",
    "select-day": "Day",
    "dock-scheduler-no-data": "Select a location and a day to view and reserve a time slot",
    "dock-schedule-table-cell-your-booking": "Your booking",
    "dock-schedule-table-cell-booked-by-other": "Booked",
    "dock-schedule-table-cell-closed": "Closed",
    "error-fetching-locations": "Failed at retrieving locations",
    "error-fetching-dock-schedule": "Failed at retrieving the schedule",
    "docking-dialog": {
      "booking-id": "@:brand.name booking reference",
      "license-plate": "License plate",
      "nationality": "Nationality",
      "remarks": "Remarks",
      "create-button": "Book",
      "title": "Docking for {dock} at {location}",
      "nationality-placeholder": "Choose a nationality",
      "remarks-placeholder": "For example loading instructions or remarks",
      "supplier-placeholder": "For example Lamb Weston",
      "license-plate-placeholder": "For example 22-BDS-02",
      "confirm-dialog": {
        "message": "Are you sure you want to remove this booking? This will be deleted for everyone."
      },
      "transporter": "Transporter",
      "booking-id-tooltip": "Inbound/outbound or purchase order number.",
      "error-remove-booking-validation": "Cancellation is not permitted within the scheduled time. Please contact your contact person within @:brand.name",
      "partner-placeholder": "Choose a partner",
      "partner": "On behalf of"
    },
    "error-fetching-bookings": "Failed at retrieving bookings",
    "success-creating-booking": "Successfully booked timeslot",
    "error-creating-booking": "Failed at booking a timeslot",
    "success-deleting-booking": "Successfully deleted booking",
    "error-deleting-booking": "Failed at deleting a booking",
    "success-updating-booking": "Successfully updated booking",
    "error-updating-booking": "Failed at updating a booking",
    "dock-schedule-table-cell-no-longer-available": "This timeslot is no longer available because it falls outside the allowed booking window.",
    "dock-schedule-table-cell-loading-reference-not-found": "Reference number could not be found",
    "dock-scheduler-closed-day": "The location is closed for the whole day.",
    "dock-schedule-table-lock-dock-tooltip": "You cannot close this dock, because there are already bookings made this day",
    "error-unlocking-dock": "Failed at unlocking the dock",
    "error-locking-timeslot": "Failed at locking the dock",
    "select-booking-period": "Booking period",
    "booking-overview-title": "Booking overview",
    "error-fetching-notifications": "Failed at retrieving notifications",
    "location-notifications": {
      "confirm-dialog": {
        "message": "Are you sure you want to delete this notification?"
      },
      "add-notification": "Create notification"
    },
    "notification-dialog": {
      "title": "Notification",
      "message": "Message",
      "is-active": "Is active"
    },
    "success-deleting-notification": "Successfully removed notification",
    "error-deleting-notification": "Failed at removing the notification",
    "success-creating-notification": "Successfully created a notification",
    "error-creating-notification": "Failed at creating a notification",
    "success-updating-notification": "Successfully updated notification",
    "error-updating-notification": "Failed at updating notification",
    "location-settings-dialog": {
      "title": "Location settings",
      "cutoff-time": "Cutoff time"
    },
    "success-updating-cutoff-time": "Cutoff time updated successfully",
    "error-updating-cutoff-time": "Failed at updating the cutoff time",
    "cutoff-time-label": "Bookings for the next day close at {time}",
    "error-fetching-partners": "Failed at retrieving partners",
    "select-docks": "Docks",
    "export-bookings-button": "Download",
    "export-bookings-subtitle": "XLSX file",
    "export-bookings-title": "Download your past bookings",
    "export-bookings-error": "Failed exporting",
    "booking-overview-table": {
      "date": "Date",
      "time": "Time",
      "location": "Location",
      "dock": "Dock",
      "reference-number": "Booking reference",
      "partner-id": "External partner"
    },
    "dock-booking-overview-no-data": "No data",
    "dock-scheduling-rules-title": "Dock scheduling rules",
    "add-dock-scheduling-rule": "New dock scheduling rule",
    "schedule-overview-table": {
      "collapseTrigger": "{name} ({count} rules)",
      "no-data": "No rules have been created yet."
    },
    "schedule-dialog": {
      "step-1-instructions": "Choose a location, dock and product group to create a new rule",
      "title": "Dock scheduling rules",
      "step-2-location": "Location",
      "step-2-selected-docks": "Docks",
      "step-2-selected-product-groups": "Product groups",
      "location": "Location",
      "docks": "Docks",
      "product-groups": "Product groups"
    },
    "error-fetching-product-groups": "Failed at receiving product groups",
    "error-updating-rule": "Failed at updating rule",
    "success-updating-rule": "Succesfully updated rule",
    "error-creating-rule": "Failed at creating a rule",
    "success-creating-rule": "Sucessfully created rule",
    "error-deleting-rule": "Failed at deleting rule",
    "success-deleting-rule": "Succesfully deleted rule ",
    "error-fetching-rules": "Failed at receiving rules",
    "error-fetching-rule": "Failed at receiving rules"
  },
  "days": {
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday"
  },
  "userMgtStore": {
    "userVendorUpdated": "Successfully updated the partner",
    "userProductGroupUpdated": "Successfully updated the product groups"
  },
  "captcha": {
    "error": "Something went wrong with the security check. Please refresh the page and try again.",
    "title": "Security verification",
    "subtitle": "Please complete the check below to continue"
  }
}